<template>
    <div class="my-order">
        <navbar :navtitle="navtitle"></navbar>
        <ul>
            <li v-if="myOrder" v-for="(item,index) of orderList" :key="index">
                <div class="desc">
                    <h3>高建华职场教学</h3>
                    <p>订购时间{{ item.created }}</p>
                    <!-- <p>退订时间 2018-12-30</p> -->
                    <p v-show="item.unsubTime">退订时间{{ item.unsubTime }}</p>
                </div>
                <div class="money">{{getPrice(item.price)}}</div>
                <div class="unsubscribe1" @click.prevent="goUnsubscribe" :data-set= "item.orderNo" v-if="!item.unsubTime">{{unsubscribeCon}}</div>
                <div class="unsubscribe2" v-else>已退订</div>
            </li>
        </ul>
        <mytoast :toastCon="toastCon" :showToast="showToast"></mytoast>
    </div>
</template>

<script>
import navbar from '@/basecomponents/navbar'
import mytoast from '@/basecomponents/Lesin-toast'
export default {
    components: {
        navbar,
        mytoast,
    },
    data(){
        return{
            navtitle:"",
            myOrder:false,
            phoneNum: 0,
            orderList: [],
            orderNo: '',
            backorderNo: '',

            unsubscribeCon:'立即退订',
            showToast: false,
            toastCon:'',
            
        }
    },
    mounted(){
        
        // this.myOrder = this.$store.state.myOrder;
        this.myOrder = true;
        this.phoneNum = localStorage.getItem('payPhoneNum') || localStorage.getItem('loginPhoneNum');

        // 获取所以订单
        this.getAllOrder();
        
    },
    methods: {
        /**
         * 退订
         */
        goUnsubscribe(e){
            var _this = this;
            // console.log(e.target.dataset.set);
            this.orderNo = e.target.dataset.set;
            _this.$ajax.get('http://114.55.87.60:8187/rest/video/unsub/'+_this.orderNo)
            .then(
                (res)=>{
                    if(res.data === true){
                        this.showToast = true;
                        this.toastCon = "退订成功";
                        this.unsubscribeCon = "已退订";
                        // 退订成功,刷新页面
                        this.getAllOrder();
                        setTimeout(function(){
                            _this.showToast = 0;
                        },1000)
                    }else{
                        this.showToast = true;
                        this.toastCon = "退订失败";
                        setTimeout(function(){
                            _this.showToast = 0;
                        },1000)
                    }
                }
            )
        },
        /**
         * 获取所以订单
         */
        getAllOrder(){
            var _this = this;
            if( !this.phoneNum){
                // console.log("没有手机号无法查询订单");
                return;
            }
            _this.$ajax.get('http://114.55.87.60:8187/rest/video/getOrder/'+ this.phoneNum)
            .then(
                (res)=>{
                    this.orderList = res.data;
                    // console.log(this.orderList);
                }
            )
        },
        /**
         * 将获取的价格转换为  -10元
         */
        getPrice(price){
            return "-"+parseInt(price)/100+"元";
        }
    }

}
</script>

<style lang="scss" scoped> 
.my-order{
    ul{
        margin-top: 84px;
        li{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 30px;
            margin-bottom: 2px;
            width: 100%;
            height: 160px;
            background-color: #fff;
            .desc{
                display: flex;
                flex-direction: column;
                justify-content: center;
                font-size: 24px;
                h3{
                    font-size: 32px;
                    margin-bottom: 30px;
                }
                p{
                    margin-bottom: 15px;
                    font-size: 24px;
                    color: #999;
                }
                
            }
            .money{
                font-size: 30px;
            }
            .unsubscribe1{
                width: 120px;
                padding: 1px 10px;
                // height: 40px;
                background-color: #28aaff;
                border-radius: 10px;
                font-size: 12px;
                color: #fff;
                letter-spacing: 2px;
                text-align: center;
                line-height: 40px;
            }
            .unsubscribe2{
                width: 120px;
                padding: 1px 10px;
                // height: 40px;
                background-color: #eee;
                border-radius: 10px;
                font-size: 12px;
                color: #fff;
                letter-spacing: 2px;
                text-align: center;
                line-height: 40px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/mine/MyOrder.vue